import React from 'react';
import { FelaKeyframe } from 'gatsby-theme-fela';
import { FelaComponent } from 'react-fela';
import { type TRuleWithTheme, useFelaEnhanced } from '@ackee/fela';

import type { UseStarsStyles } from 'utils/hooks/useStars';

import * as felaRules from './ColorLine.rules';

export interface ColorLineProps extends UseStarsStyles {
    className?: string;
    keyframe: TRuleWithTheme;
    animationTimeMS: number;
}

export const ColorLine = ({ className, keyframe, animationTimeMS, ...rest }: ColorLineProps) => {
    const { styles } = useFelaEnhanced(felaRules, { animationTimeMS, ...rest });

    if (keyframe) {
        return (
            <FelaKeyframe keyframe={keyframe}>
                {(animationName: string) => (
                    <FelaComponent
                        style={felaRules.floatingLine}
                        animationTimeMS={animationTimeMS}
                        animationName={animationName}
                    >
                        {({ className }) => <span className={`${styles.line} ${className}`}></span>}
                    </FelaComponent>
                )}
            </FelaKeyframe>
        );
    }
    return <span className={`${styles.line} ${className}`}></span>;
};
